export const parseGameFeeds = (feeds = []) =>
    feeds.map(feed => ({
        ...feed,
        categories: feed.categories.map(({ cid, name, gameCodes, roundIcon, pgg2, customLayout }) => ({
            cid,
            name,
            gameCodes,
            roundIcon,
            pgg2,
            displayName: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.long`,
            displayNameShort: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.short`,
            customLayout // ~(Sportium Changes)~
        }))
    }));
